<div class="empty-block">
  <mat-icon class="empty-block__icon" *ngIf="emptyIcon" [svgIcon]="emptyIcon"></mat-icon>
  <p class="empty-block__message">{{ emptyMessage | translate }}</p>
  <button *ngIf="reloadButtonName" class="empty-block__btn" mat-flat-button (click)="reload.emit()">
    {{ reloadButtonName }}
  </button>
</div>
